
























































































































import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import {
  computed,
  defineComponent,
  nextTick,
  ref
} from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import ClassifiedExternalCertificatesService from '~/services/classified/ClassifiedExternalCertificatesService'
import { formFieldProps } from '~/constants/form'
import { removeNullValues } from '~/utils/object'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { useLogger } from '~/compositions/logger'
import { useI18n } from '~/compositions/i18n'
import FieldHandlerContainer from '~/components/car/classifieds/form/fieldsets/fields/FieldHandlerContainer.vue'

export default defineComponent({
  props: formFieldProps,
  components: { FieldHandlerContainer, FieldError, CAvatar },
  setup(props) {
    const { specs, name } = props
    const hasExternalCertificates = ref(false)
    const reportId = ref(null)
    const vinDigits = ref(null)
    const selectedProviderId = ref(null)
    const reportIdError = ref(null)
    const vinDigitsError = ref(null)
    const providerError = ref(null)
    const verificationError = ref(null)
    const isLoading = ref(false)
    const isCertificateValid = ref(null)
    const isSuccessAlertVisible = ref(false)
    const verified = ref(false)

    function onValue(v: Ref<any>) {
      if (v.value) {
        reportId.value = v.value.report_id
        selectedProviderId.value = v.value.provider_id
        if (selectedProviderId.value) {
          hasExternalCertificates.value = true
        }
        vinDigits.value = v.value.vin_digits
        verified.value = v.value.verified
      }
    }

    function onError(e: Ref<any>) {
      if (e.value) {
        providerError.value = e.value.provider_id
        reportIdError.value = e.value.report_id
        vinDigitsError.value = e.value.vin_digits
        verificationError.value = e.value.verified
      }
    }
    const { inEditMode, valueChanged } = useClassifiedForm(props, {
      onValue,
      onError
    })
    const formValidationBuilder = useDep(FormValidationBuilder)

    const logger = useLogger()
    const { t } = useI18n()
    const externalCertificatesService = useDep(
      ClassifiedExternalCertificatesService
    )

    const providersOptions = computed(() => [
      {
        text: t('choose provider'),
        value: null
      },
      ...specs.providers.values.map(v => ({
        value: v.id,
        text: v.name
      }))
    ])
    const selectedProvider = computed(() => {
      const { values } = specs.providers

      if (values) {
        const img = values.find(v => v.id === selectedProviderId.value)
        return removeNullValues({
          ...providersOptions.value.find(
            p => p.value === selectedProviderId.value
          ),
          img: img ? img.photo : null
        })
      }
      return null
    })
    const icons = computed(() => {
      return {
        info: faInfoCircle
      }
    })
    /*
       @TODO inEditMode is not work properly.
       Has wrong value(true) on insert.
       uncomment the lines below when we have multiple providers
    */
    const addCertificatesText: string = computed(() => {
      return ''
      // if (inEditMode) {
      //   return t('certificate files can be added')
      // }
      // return `${t('certificate files can be added')} ${i18n
      //   .t('after classified registration')
      //   .toLowerCase()}`
    })
    const handleEmitValues = () => {
      if (!reportId.value && !vinDigits.value) {
        valueChanged(name, null)
        return
      }
      valueChanged(name, {
        report_id: reportId.value,
        vin_digits: vinDigits.value,
        provider_id: selectedProviderId.value,
        verified: verified.value
      })
      isCertificateValid.value = null
      isSuccessAlertVisible.value = false
    }

    const handleProviderChange = (provider: string) => {
      verified.value = false
      selectedProviderId.value = provider
      reportId.value = null
      vinDigits.value = null
      providerError.value = null
      reportIdError.value = null
      vinDigitsError.value = null
      verificationError.value = null
      verified.value = false
      if (!provider) {
        valueChanged(name, null)
      } else {
        handleEmitValues()
      }
    }

    const validateVinDigits: boolean = vinDigits => {
      const vinDigitsSpecs = specs.vin_digits
      formValidationBuilder
        .new(vinDigitsError)
        .required(vinDigitsSpecs.required, vinDigits)
        .minChars(vinDigitsSpecs.min, vinDigits, true)
        .maxChars(vinDigitsSpecs.max, vinDigits)
        .validate()
      return !vinDigitsError.value
    }

    const handleVinDigitsInput = (vinDigits: string) => {
      verified.value = false
      validateVinDigits(vinDigits)
      handleEmitValues()
    }

    const validateReportId: boolean = reportId => {
      const reportIdSpecs = specs.report_id
      formValidationBuilder
        .new(reportIdError)
        .required(reportIdSpecs.required, reportId)
        .minChars(reportIdSpecs.min, reportId)
        .maxChars(reportIdSpecs.max, reportId)
        .validate()
      return !reportIdError.value
    }
    const handleReportIdInput = (reportId: string) => {
      verified.value = false
      validateReportId(reportId)
      handleEmitValues()
    }
    const handleClickAddCertificate = () => {
      const { origin, pathname, search } = window.parent.location
      window.parent.location.href = `${origin}${pathname}${search}#certificates`
      window.parent.location.reload()
    }

    const isNumber = evt => {
      evt = evt || window.event
      const charCode = evt.which || evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      }
      return true
    }

    const validateExternalCertificate = async () => {
      if (
        !selectedProviderId.value ||
        !validateReportId(reportId.value) |
          (specs.vin_digits.required && !validateVinDigits(vinDigits.value))
      ) {
        return
      }
      isLoading.value = true
      try {
        const isValid: boolean = await externalCertificatesService.validateExternalCertificate(
          {
            providerId: selectedProviderId.value,
            reportId: reportId.value,
            vinDigits: vinDigits.value
          }
        )
        verified.value = true
        handleEmitValues()
        isCertificateValid.value = isValid
        isSuccessAlertVisible.value = true
        verificationError.value = null
      } catch (error) {
        if (error.response.status === 400) {
          verified.value = false
          handleEmitValues()
          isCertificateValid.value = false
        }
        logger.captureError(error)
      } finally {
        isLoading.value = false
      }
    }

    const reportNotFoundError = computed(() =>
      t(
        'the report not found, please complete the fields with the right numbers or clear them and continue to the next section.'
      )
    )

    const handleHasExternalCertificates = (hasExternal: boolean) => {
      if (hasExternal) {
        hasExternalCertificates.value = hasExternal
        handleEmitValues()
      } else {
        if (
          verified.value &&
          !confirm(t('this action will remove the saved certificate'))
        ) {
          nextTick(() => {
            hasExternalCertificates.value = true
          })
          return
        }
        hasExternalCertificates.value = hasExternal
        valueChanged(name, null)
      }
    }

    return {
      reportId,
      inEditMode,
      providersOptions,
      vinDigits,
      selectedProviderId,
      reportIdError,
      vinDigitsError,
      providerError,
      verificationError,
      isLoading,
      isCertificateValid,
      isSuccessAlertVisible,
      verified,
      selectedProvider,
      addCertificatesText,
      handleProviderChange,
      handleVinDigitsInput,
      handleReportIdInput,
      handleClickAddCertificate,
      isNumber,
      validateExternalCertificate,
      icons,
      reportNotFoundError,
      hasExternalCertificates,
      handleHasExternalCertificates
    }
  }
})
